<template>
  <div id="login">
    <div class="login-card">

      <div class="card-title">
        <h1>Cirrus Separations</h1>
      </div>

      <div class="content">
        <form method="POST" @submit.prevent="sendForm">
          <input id="username" type="text" name="username" title="username" placeholder="Username" v-model="username"
                 required autofocus>
          <input id="password" type="password" name="password" title="password" placeholder="Password"
                 v-model="password" required>
          <button type="submit" class="btn btn-primary">Login</button>
        </form>
      </div>

    </div>
  </div>
</template>

<script>

  export default {
    name: "Login",
    data() {
      return {
        username: "",
        password: "",
      }
    },
    methods: {
      async sendForm() {
        try {
          await this.$store.dispatch("auth/obtainToken", {
            username: this.username,
            password: this.password,
          })
          await this.$router.push("/")
          await this.$store.dispatch("auth/obtainUserInfo",{
            username:this.username
          })
        } catch (err) {
          console.log(err)
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  $primary: #164aef;;
  $grey-darker: hsl(0, 0%, 21%);
  $grey-dark: hsl(0, 0%, 29%);
  $grey: hsl(0, 0%, 48%);
  $grey-light: hsl(0, 0%, 71%);
  $grey-lighter: hsl(0, 0%, 86%);

  #login {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    background: #F7F7F7;

    .login-card {
      background: #fff;
      width: 24rem;
      box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.11);

      .card-title {
        background-color: darken($primary, 5%);
        padding: 1rem;

        h1 {
          color: #fff;
          text-align: center;
          font-size: 2rem;
        }
      }

      .content {
        padding: 2.5rem 2.5rem 3rem;
      }

      #username, #password {
        display: block;
        width: 100%;
        font-size: 1rem;
        margin-bottom: 1.75rem;
        padding: 0.25rem 0;
        border: none;
        border-bottom: 1px solid $grey-lighter;
        transition: all .5s;

        &:hover {
          border-color: $grey;
        }

        &:active, &:focus {
          border-color: $primary;
        }
      }

      .checkbox {
        color: $grey-light;
        font-size: 0.8rem;

        span {
          margin-left: 0.5rem;
        }
      }

      a {
        font-size: 0.8rem;
      }

      .options {
        color: $grey-light;
        margin-bottom: 1.5rem;
      }

      button {
        cursor: pointer;
        font-size: 1.2rem;
        color: $primary;
        border-radius: 4rem;
        display: block;
        width: 100%;
        background: transparent;
        border: 2px solid $primary;
        padding: 0.9rem 0 1.1rem;
        transition: color .5s, border-color .5s;

        &:hover, &:focus {
          color: darken($primary, 10%);
          border-color: darken($primary, 10%);
        }

        &:active {
          transform: translateY(1px);
        }
      }
    }
  }

  label {
    cursor: pointer;
  }

  input:focus,
  select:focus,
  textarea:focus,
  button:focus {
    outline: none;
  }
</style>
